import { Icon } from '@ps/isp-web-component-library';
import { ChevronMediumDown } from '@ps/isp-web-component-library/icons/ChevronMediumDown';
import classNames from 'clsx';
import React from 'react';

import styles from './Title.scss';

interface Props {
  children: React.ReactNode;
  isOpen?: boolean;
  isNested?: boolean;
  isLight?: boolean;
  hasLink?: boolean;
  hasIcon?: boolean;
}

const Title: React.FC<Props> = ({
  children,
  isOpen = false,
  isNested = false,
  isLight = false,
  hasLink = false,
  hasIcon = false
}) => (
  <div
    className={classNames(styles.titleWrapper, {
      [styles.open]: isOpen,
      [styles.isLight]: isLight && isNested,
      [styles.isNested]: isNested,
      [styles.hasLink]: hasLink,
      [styles.hasIcon]: hasIcon
    })}
  >
    <div className={styles.title}>{children}</div>
    {!isNested ? (
      <Icon
        icon={ChevronMediumDown}
        className={classNames(styles.icon, {
          [styles.iconOpen]: isOpen
        })}
        size="x1"
      />
    ) : null}
  </div>
);

export default Title;
